import Column from "./models/Column";
import {Product} from "./models/product";
import InPaceService from "./services/InPaceService";
import {LMColumn} from "./components/Tables/types";
import InCareNetHFService from "./services/InCareNetHFService";
import { NetECGService } from "./services/NetECGService";
import {compareCustomerNumbers} from "./utils/customerNumberSort";

export const firstLevelSupport: string[] = [
  'Semdatex'
]

export const businessAuditLogTableColumns: Column[] = [
  {
    field: 'timestamp',
    headerName: 'objects.businessAuditLog.timestamp',
    width: 200
  },
  {
    field: 'customerId',
    headerName: 'objects.businessAuditLog.customerId',
    width: 150
  },
  {
    field: 'message',
    headerName: 'objects.businessAuditLog.message',
    width: 300
  },
  {
    field: 'username',
    headerName: 'objects.businessAuditLog.username',
    width: 150
  },
  {
    field: 'prevValue',
    headerName: 'objects.businessAuditLog.prevValue',
    width: 250
  },
  {
    field: 'newValue',
    headerName: 'objects.businessAuditLog.newValue',
    width: 250
  },
  {
    field: 'userRole',
    headerName: 'objects.businessAuditLog.userRole',
    width: 150
  },
]

export const errorLogTableColumns: Column[] = [
  {
    field: 'timestamp',
    headerName: 'objects.errorLog.timestamp',
    width: 200
  },
  {
    field: 'level',
    headerName: 'objects.errorLog.level',
    width: 100
  },
  {
    field: 'message',
    headerName: 'objects.errorLog.message',
    width: 300
  },
  {
    field: 'username',
    headerName: 'objects.errorLog.username',
    width: 150
  },
  {
    field: 'userRole',
    headerName: 'objects.errorLog.userRole',
    width: 150
  },
  {
    field: 'method',
    headerName: 'objects.errorLog.method',
    width: 250
  },
  {
    field: 'statusCode',
    headerName: 'objects.errorLog.statusCode',
    width: 120
  },
  {
    field: 'stackTrace',
    headerName: 'objects.errorLog.stackTrace',
    width: 300
  },
  {
    field: 'metadata',
    headerName: 'objects.errorLog.metadata',
    width: 200
  },
]

export const salesPersonTableColumns: Column[] = [
  {
    field: 'lastName',
    headerName: 'objects.salesperson.lastName',
    width: 350
  },
  {
    field: 'disabled',
    headerName: 'objects.salesperson.disabled',
    width: 350,
    iconFromBool: true,
  },
]

export const InCareNetTableColumns: Column[] = [
  {
    field: "customerName",
    headerName: "objects.customer.customerName",
    width: 200
  },
  {
    field: "customerNumber",
    headerName: "objects.customer.customerNumber",
    width: 130,
    sortComparator: compareCustomerNumbers,
  },
  {
    field: "location",
    headerName: "objects.address.location",
  },
  {
    field: "version",
    headerName: "objects.products.sol.incarenethf.version",
    width: 80
  },
  {
    field: "externalSensors",
    headerName: 'objects.products.sol.incarenethf.totalExtSens',
    width: 150,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "activeAbbott",
    headerName: "objects.products.sol.incarenethf.abbottActive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "activeBio",
    headerName: "objects.products.sol.incarenethf.biotronikActive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "activeBoston",
    headerName: "objects.products.sol.incarenethf.bostonActive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "activeMedtronic",
    headerName: "objects.products.sol.incarenethf.medtronicActive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "activeMicroPort",
    headerName: "objects.products.sol.incarenethf.microportActive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "totalActiveImplants",
    headerName: 'objects.products.sol.incarenethf.totalImpl',
    width: 150,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "inactiveAbbott",
    headerName: 'objects.products.sol.incarenethf.abbottInactive',
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "inactiveBio",
    headerName: "objects.products.sol.incarenethf.biotronikInactive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "inactiveBoston",
    headerName: "objects.products.sol.incarenethf.bostonInactive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "inactiveMedtronic",
    headerName: "objects.products.sol.incarenethf.medtronicInactive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "inactiveMicroPort",
    headerName: "objects.products.sol.incarenethf.microportInactive",
    width: 70,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "totalInactiveImplants",
    headerName: `objects.products.sol.incarenethf.totalInactiveImpl`,
    width: 150,
    warnIconIfError: InCareNetHFService.isDeviceCountValid,
  },
  {
    field: "implantConnectionRate",
    headerName: 'objects.products.sol.incarenethf.implantConnectionRate',
    width: 150,
  },
  {
    field: "url",
    headerName: 'objects.products.sol.incarenethf.url',
    width: 150
  },
  {
    field: "lastRefreshTimestamp",
    headerName: 'objects.products.sol.incarenethf.lastRefreshTimestamp',
    width: 160,
    formatTimestamp: true,
  },
  {
    field: "lastRefreshSuccess",
    headerName: 'objects.products.sol.incarenethf.lastRefreshSuccess',
    width: 100,
    statusIcon: true,
  },
  {
    field: "tmzActiveSince",
    headerName: 'objects.products.sol.incarenethf.tmzActiveSince',
    width: 130
  },
  {
    field: "priceSensorsPerPatient",
    headerName: 'objects.products.sol.incarenethf.priceSensorsPerPatient'
  },
  {
    field: "priceImplantsPerPatient",
    headerName: 'objects.products.sol.incarenethf.priceImplantsPerPatient'
  },
  {
    field: "getemedHotlineSupport",
    headerName: 'objects.products.sol.incarenethf.getemedHotlineSupport',
    iconFromBool: true,
    width: 200
  },
  {
    field: "os",
    headerName: 'objects.products.sol.incarenethf.os'
  },
  {
    field: "system",
    headerName: 'objects.customer.system',
  },
  {
    field: "disabled",
    headerName: 'common.deactivated',
    iconFromBool: true,
  }
]

export const InPaceTableColumns: Column[] = [
  {
    field: "customerName",
    headerName: 'objects.customer.customerName',
    width: 200
  },
  {
    field: "customerNumber",
    headerName: 'objects.customer.customerNumber',
    width: 120,
    sortComparator: compareCustomerNumbers,
  },
  {
    field: "location",
    headerName: 'objects.address.location',
  },
  {
    field: "serialNr",
    headerName: 'objects.products.inpace.serialNr',
    width: 180
  },
  {
    field: "softwareVn",
    headerName: 'objects.products.inpace.softwareVn',
  },
  {
    field: "manufacturer",
    headerName: 'objects.products.inpace.manufacturer',
  },
  {
    field: "deviceName",
    headerName: 'objects.products.inpace.deviceName',
  },
  {
    field: "licenceStart",
    headerName: 'objects.products.inpace.licenseStart',
    width: 120
  },
  {
    field: "licenceEnd",
    headerName: 'objects.products.inpace.licenceEnd',
    width: 120
  },
  {
    field: "dateOfActivation",
    headerName: 'objects.products.inpace.dateOfActivation',
    width: 130
  },
  {
    field: "licenceValid",
    headerName: 'objects.products.inpace.licenceValid',
    width: 80,
  },
  {
    field: "additionalNotes",
    headerName: 'objects.products.inpace.additionalNotes',
    width: 200
  },
  {
    field: "soldToBiotronik",
    headerName: 'objects.products.inpace.soldToBiotronik',
    width: 120
  },
  {
    field: "deviceType",
    headerName: 'objects.products.inpace.deviceType',
  },
  {
    field: "numberOfSubdevices",
    headerName: 'objects.products.inpace.numberOfSubdevices',
    width: 140
  },
]

export const subDeviceColumns: LMColumn[] = [
  {
    field: "subDeviceNo",
    headerName: 'objects.products.inpace.subDeviceNo',
    flex: 20,
  },
  {
    field: "einstellung",
    headerName: 'objects.products.inpace.settings',
    flex: 20,
  },
  {
    field: "subDeviceSoftwareVn",
    headerName: 'objects.products.inpace.softwareVn',
    flex: 20,
  }
]

export const NetECGTableColumns: Column[] = [
  {
    field: 'customerName',
    headerName: 'objects.customer.customerName',
    width: 200,
  },
  {
    field: 'customerNumber',
    headerName: 'objects.customer.customerNumber',
    width: 200,
    sortComparator: compareCustomerNumbers,
  },
  {
    field: 'serialNumber',
    headerName: 'objects.products.netecg.serialNumber',
    width: 200
  },
  {
    field: 'serialNumberChargingDock',
    headerName: 'objects.products.netecg.serialNumberChargingDock',
    width: 200
  },
  {
    field: 'batchNumber',
    headerName: 'objects.products.netecg.batchNumber',
    width: 200
  },
  {
    field: 'evaluationSoftware',
    headerName: 'objects.products.netecg.evaluationSoftware',
    width: 200
  }
]

export const CustomerTableColumns: Column[] = [
  {
    field: "name",
    headerName: 'objects.customer.customerName',
    width: 200
  },
  {
    field: "doctorName",
    headerName: 'objects.customer.doctorName',
    width: 150
  },
  {
    field: "customerNumber",
    headerName: 'objects.customer.customerNumber',
    sortComparator: compareCustomerNumbers,
  },
  {
    field: "postalCode",
    headerName: 'objects.address.postalCode',
    width: 70
  },
  {
    field: "location",
    headerName: 'objects.address.location',
  },
  {
    field: "street",
    headerName: 'objects.address.street',
    width: 150
  },
  {
    field: "system",
    headerName: 'objects.customer.system',
    width: 150
  },
  {
    field: "biotronikClientName",
    headerName: 'objects.customer.biotronikClientName',
    width: 200
  },
  {
    field: "biotronikCustomerNumber",
    headerName: 'objects.customer.biotronikCustomerNumber',
    sortComparator: compareCustomerNumbers,
  },
  {
    field: "eTin",
    headerName: 'objects.customer.eTin',
  },
  {
    field: "bostonSAPID",
    headerName: 'objects.customer.bostonSAPID',
    width: 120
  },
  {
    field: "salesperson",
    headerName: 'objects.customer.salesperson',
    width: 150
  },
]

const VIEWER_HIDDEN_INCARENETHF_FIELDS = ['priceSensorsPerPatient', 'priceImplantsPerPatient'];

// Customer master data no longer carries price fields (prices live on the
// InCareNet HF product), so viewers see the same customer columns as admins.
export const ViewerCustomerTableColumns: Column[] = CustomerTableColumns;

export const InCareNetViewerTableColumns: Column[] = InCareNetTableColumns.filter(
  col => !VIEWER_HIDDEN_INCARENETHF_FIELDS.includes(col.field)
);

export const Products: Product[] = [
  {
    name: "inCareNetHF",
    label: "INCARENET HF",
    getTableItems: InCareNetHFService.getTableInCareNetHFData,
    getData: InCareNetHFService.getInCareNetHFs,
    deleteItem: InCareNetHFService.deleteInCareNetHF,
    tableColumns: InCareNetTableColumns,
  },
  {
    name: "inPace",
    label: "INPACE",
    getTableItems: InPaceService.getTableDeviceData,
    getData: InPaceService.getInPaceDevices,
    deleteItem: InPaceService.deleteDevice,
    tableColumns: InPaceTableColumns,
  },
  {
    name: "netECG",
    label: "net_ECG",
    getTableItems: NetECGService.getNetECGs,
    getData: NetECGService.getNetECGs,
    deleteItem: NetECGService.deleteNetECG,
    tableColumns: NetECGTableColumns
  }
]

export const columnSpacing = 5

export const defaultTextFieldWidth = {
  width: "15rem"
}

export const FormIds = {
  billingConfig: "billing-config-form",
  updateCustomer: "update-customer-form",
  updateSalesPerson: "update-sales-person",
  updateInCareNetHF: "add-icnhf-form",
  updateInPace: "add-inpace-form",
  updateNetECG: "add-netecg-form",
  subDevice: "subdevice-form"
}

export const inActiveFieldNames = [
  "inactiveAbbott",
  "inactiveBio",
  "inactiveBoston",
  "inactiveMedtronic",
  "inactiveMicroPort",
  "totalInactiveImplants",
]
export const activeFieldNames = [
  "activeAbbott",
  "activeBio",
  "activeBoston",
  "activeMedtronic",
  "activeMicroPort",
  "externalSensors",
  "totalActiveImplants"
]

declare global {
  interface Window {
    __CONFIG__?: {
      SERVER_DOMAIN?: string;
    };
  }
}

export const serverDomain = window.__CONFIG__?.SERVER_DOMAIN
  ? `https://${window.__CONFIG__.SERVER_DOMAIN}`
  : 'http://localhost:3001'
